module.exports = __webpack_public_path__ + "img/006-pencil.fe3944a2.svg";